module.exports = __webpack_public_path__ + "static/media/black.628b365e.PNG";